/* Las reglas del campo de la descripción, compartidas por la pantalla de inicio
   y el primer paso del asistente (ver `PromptComposer`). */

/** Lo que hace falta para que la IA tenga algo con lo que trabajar. */
export const MIN_PROMPT = 20

/**
 * Lo más largo que se acepta, el mismo tope que el worker. Era 600 y cortaba un
 * encargo detallado —secciones, textos, paleta— a la mitad sin avisar.
 */
export const MAX_PROMPT = 5000

/* Arranques amplios, por tipo de negocio, para no hacerle creer a nadie que
   tiene que copiar una ciudad, un tono o una estructura concretos. Al pulsar
   uno se escribe entero en el campo: sirve de punto de partida, no de valor
   cerrado, y después se puede editar con normalidad. */
/**
 * Las ideas de arranque, en claves.
 *
 * El texto largo no es de pantalla: es lo que se le manda a la IA. Traducirlo no
 * es cosmética — es lo que hace que a quien tiene el panel en inglés le salga un
 * sitio en inglés en vez de uno en español que luego hay que rehacer entero.
 */
export const PROMPT_TEMPLATES = [
  { label: 'cwa.tpl.services', prompt: 'cwa.tpl.servicesPrompt' },
  { label: 'cwa.tpl.restaurant', prompt: 'cwa.tpl.restaurantPrompt' },
  { label: 'cwa.tpl.shop', prompt: 'cwa.tpl.shopPrompt' },
  { label: 'cwa.tpl.wellness', prompt: 'cwa.tpl.wellnessPrompt' },
  { label: 'cwa.tpl.portfolio', prompt: 'cwa.tpl.portfolioPrompt' },
] as const
